import finmetrixColors from '../helpers/finmetrix-colors'

const $ = kendo.jQuery

function renderChart($container, options, renderLocation) {
  return new Promise(function(resolve) {
    const actionName = renderLocation === 'report' ? 'dataSource' : 'dataSourceComponentByDate'
    const chart = $('<div></div>').appendTo($container)
    const dataSourceUrl = `/api/heroux/ExposureReport/${actionName}`

    $.get(dataSourceUrl, options, function(response) {
      const data = response.data.filter(el => el.Period != 'Grand Total')
      const {typeNumCols, ccyPair, fromDate, clientName, division} = response

      buildExposureChart(
        chart,
        data,
        typeNumCols,
        ccyPair,
        fromDate,
        clientName,
        division,
        renderLocation,
      ).then(function(eChart) {
        resolve(eChart)
      })
    })
  })
}

function buildExposureChart(
  element,
  data,
  typeNumCols,
  ccyPair,
  fromDate,
  clientName,
  division,
  renderLocation,
) {
  return new Promise(function(resolve) {
    const pdf = renderLocation === 'dashboard'
    const text = !pdf
      ? ccyPair +
        ' - ' +
        division +
        ' Exposure - thousands of USD ' +
        '\n' +
        clientName +
        ' - ' +
        kendo.toString(kendo.parseDate(fromDate), 'MMMM-yyyy')
      : division

    const getTypeNumName = id => typeNumCols.filter(el => el.typeNumId === id)[0].typeNumName

    const risqueNetText = getTypeNumName(4)

    const hedgeText = getTypeNumName(5)

    $(element)
      .kendoChart({
        renderAs: pdf ? 'canvas' : 'svg',
        transitions: !pdf,
        title: {
          text: text,
          padding: {
            bottom: 5,
          },
        },
        legend: {
          position: 'bottom',
          item: {
            visual: makeVisualLegend,
          },
        },
        dataSource: data,
        seriesDefaults: {
          type: 'column',
        },
        series: [
          {
            field: 'RisqueNetChart',
            name: risqueNetText,
            axis: 'axis1',
            color: finmetrixColors.Blue,
            labels: {
              visible: false,
            },
          },
          {
            field: 'HedgeChart',
            name: hedgeText,
            axis: 'axis1',
            color: finmetrixColors.Green,
            //color: ccyPairColor + "82",
            labels: {
              font: '10px Arial',
              visible: true,
              rotation: -45,
              background: 'transparent',
              padding: {
                top: 2,
                left: 1,
              },
              template: function(item) {
                var percentage = item.dataItem.Hedge_Ratio

                if (isNaN(percentage) || !isFinite(percentage) || percentage === 0) {
                  return ''
                }
                return kendo.toString(percentage, 'P2')
              },
            },
          },
          {
            field: 'Level',
            name: ccyPair,
            //color: "rgba(255,255,255, 0)",
            type: 'line',
            markers: {
              visible: false,
            },
            format: '{0:N4}',
            axis: 'levelAxis',
            tooltip: {
              visible: true,
              format: '{0:N4}',
            },
          },
        ],
        valueAxes: [
          {
            name: 'axis1',
            labels: {
              format: '{0:N0}',
              font: '10px Arial',
            },
            title: {
              text: 'thousands of USD',
              font: '10px Arial',
            },
          },
          {
            name: 'levelAxis',
            labels: {
              format: '{0:N4}',
              font: '10px Arial',
            },
          },
        ],
        categoryAxis: {
          field: 'Period',
          labels: {
            visible: true,
            font: '10px Arial',
            rotation: -45,
            background: 'transparent',
            padding: {
              top: 15,
              left: 1,
            },
          },
          axisCrossingValues: [0, 500],
        },
        tooltip: {
          visible: true,
          format: '{0:N0}',
        },
        render: function(e) {
          if (renderLocation === 'dashboard') {
            var items = e.sender.dataSource.data().length
            if (items == 0) {
              e.sender.element.closest('.component').remove()
            }
          }
          resolve(element.getKendoChart())
        },
      })
      .data('kendoChart')
  })
}

function makeVisualLegend(e) {
  var color = e.options.markers.background
  var labelColor = e.options.labels.color
  var imageSrc = ''
  if (color === 'rgba(255,255,255, 0)') {
    color = finmetrixColors.LightGray
    imageSrc = '/img/markers/line.png'
  } else if (color === 'rgba(255,255,255, 0.0001)') {
    color = finmetrixColors.Blue
    imageSrc = '/img/markers/diamond.png'
  }
  var rectContainer = new kendo.geometry.Rect([0, 0], ['100%', 50])
  var layout = new kendo.drawing.Layout(rectContainer, {
    spacing: 3,
    alignItems: 'center',
  })
  var label = new kendo.drawing.Text(e.series.name + ' ', [10, 0], {
    fill: {
      color: labelColor,
    },
    font: '9px Arial',
  })
  var marker, rectGeometry

  if (imageSrc === '') {
    rectGeometry = new kendo.geometry.Rect([0, 0], [10, 3])
    marker = new kendo.drawing.Rect(rectGeometry).stroke(labelColor, 0).fill(color)
  } else {
    rectGeometry = new kendo.geometry.Rect([0, -6], [10, 10])
    marker = new kendo.drawing.Image(imageSrc, rectGeometry)
  }
  layout.append(marker, label)
  layout.reflow()
  return layout
}

export default {
  render: function($container, options, location = 'dashboard') {
    return renderChart($container, options, location)
  },
}
